var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"alertUp",attrs:{"width":1000000,"type":_vm.type},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._v(" "+_vm._s(_vm.msg)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }